import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_ACCOUNT_CONFIG_API_BASE_URL;
const authBaseUrl = apiClient.REACT_APP_AUTH_API_BASE_URL;
const baseUrlUser = apiClient.REACT_APP_USER_API_BASE_URL;

export function listAdAccounts() {
  const url = joinUrlWithRoute(baseUrl, "/listAdAccounts");
  return apiClient.get(url);
}

export function changeConfiguration(request) {
  const url = joinUrlWithRoute(baseUrl, "/app-setup");
  return apiClient.post(url, request);
}

export function saveAccountIntelligenceContext(request, options) {
  const url = joinUrlWithRoute(baseUrl, "/account-intelligence");
  return apiClient.put(url, request, options);
}

export function getAccountIntelligenceContext(options) {
  const url = joinUrlWithRoute(baseUrl, "/account-intelligence");
  return apiClient.get(url, options);
}

export function testAnyCrmConnection() {
  const url = joinUrlWithRoute(baseUrl, "/anycrm/test-connection");
  return apiClient.post(url, {});
}

export function disconnectLinkedinAccount() {
  const url = joinUrlWithRoute(baseUrl, "/account-disconect");
  return apiClient.put(url, {});
}

export function getLinkedinAdsAuthorizeUrl() {
  const url = joinUrlWithRoute(authBaseUrl, "/linkedin-ads/oauth/authorize-url");
  return apiClient.get(url);
}

export async function getLinkedinAuthorization() {
  const response = await getLinkedinAdsAuthorizeUrl();
  const payload = response?.data?.data ?? response?.data ?? {};
  const authorizeUrl = String(payload?.authorizeUrl || "").trim();
  if (!authorizeUrl) {
    throw new Error("LinkedIn Ads authorize URL unavailable.");
  }
  window.location.href = authorizeUrl;
}

export function refreshAuthorization() {
  const url = joinUrlWithRoute(baseUrlUser, "/refresh");
  return apiClient.post(url, {});
}
  // export function logout() {
  //   const url = joinUrlWithRoute(baseUrl, "logout");
  //   return apiClient.httpDelete(url);
  // }
  
  export function postConfiguration() {
    return apiClient.get(baseUrl);
  }

  export function getUsers() {
    const url = joinUrlWithRoute(baseUrl, "/users");
    return apiClient.get(url);
  }
